import { render, staticRenderFns } from "./VideoTest.vue?vue&type=template&id=af28e2f6&scoped=true&"
import script from "./VideoTest.vue?vue&type=script&lang=js&"
export * from "./VideoTest.vue?vue&type=script&lang=js&"
import style0 from "./VideoTest.vue?vue&type=style&index=0&id=af28e2f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af28e2f6",
  null
  
)

export default component.exports